import React from 'react';
import { useToken } from '@rexlabs/styling';

export function withToken(Component) {
  return (props) => {
    const token = useToken();
    return <Component token={token} {...props} />;
  };
}
